module.exports = __webpack_public_path__ + "img/Ruri_campe.09a0076d.png";